import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomSnackbar from "../../components/Message.Component";

export default function SkuDialog({ open, onClose, onSave, initialData }) {
  const [code, setCode] = useState("");
  const [imported, setImported] = useState("não");
  const [icms, setIcms] = useState("");

  const [errorCode, setErrorCode] = useState("");
  const [errorImported, setErrorImported] = useState("");
  const [errorIcms, setErrorIcms] = useState("");

  const [alert, setAlert] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    if (open) {
      setCode(initialData?.code || "");
      setImported(initialData?.imported ? "sim" : "não");
      setIcms(initialData?.icms?.toString() || "");
      setErrorCode("");
      setErrorImported("");
      setErrorIcms("");
    }
  }, [initialData, open]);

  const validateFields = () => {
    let isValid = true;

    if (!code.trim()) {
      setErrorCode("SKU é obrigatório.");
      isValid = false;
    } else {
      setErrorCode("");
    }

    if (imported !== "sim" && imported !== "não") {
      setErrorImported("Selecione se é importado ou não.");
      isValid = false;
    } else {
      setErrorImported("");
    }

    const icmsValue = parseFloat(icms);
    if (!icms || isNaN(icmsValue) || icmsValue < 0 || icmsValue > 1) {
      setErrorIcms("ICMS deve ser um número entre 0 e 1.");
      isValid = false;
    } else {
      setErrorIcms("");
    }

    return isValid;
  };

  const saveChanges = () => {
    if (!validateFields()) return;

    const newSku = {
      code,
      imported: imported === "sim",
      icms: parseFloat(icms),
    };

    setSuccessMsg(
      initialData ? "SKU atualizado com sucesso" : "SKU criado com sucesso"
    );
    setAlert(true);
    onSave(newSku);
    onClose();
  };

  return (
    <>
      <CustomSnackbar
        open={alert}
        onClose={() => setAlert(false)}
        severity="success"
        message={successMsg}
        autoHideDuration={3000}
      />
      <Dialog
        open={open}
        onClose={() => onClose(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>{initialData ? "Editar SKU" : "Criar SKU"}</span>
          <IconButton onClick={() => onClose(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            label="SKU"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            margin="normal"
            error={!!errorCode}
            helperText={errorCode}
          />

          <FormControl fullWidth margin="normal" error={!!errorImported}>
            <InputLabel id="imported-label">Importado</InputLabel>
            <Select
              labelId="imported-label"
              value={imported}
              label="Importado"
              onChange={(e) => setImported(e.target.value)}
            >
              <MenuItem value="sim">Sim</MenuItem>
              <MenuItem value="não">Não</MenuItem>
            </Select>
            {errorImported && <FormHelperText>{errorImported}</FormHelperText>}
          </FormControl>

          <TextField
            label="ICMS (ex: 0.18)"
            value={icms}
            onChange={(e) => setIcms(e.target.value)}
            fullWidth
            margin="normal"
            error={!!errorIcms}
            helperText={errorIcms}
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => onClose(false)}
            variant="outlined"
            sx={{
              borderColor: "#f44336",
              color: "#f44336",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#fdecea",
                borderColor: "#d32f2f",
                color: "#d32f2f",
              },
            }}
          >
            Cancelar
          </Button>

          <Button
            onClick={saveChanges}
            variant="contained"
            sx={{
              backgroundColor: "#e8f5e9",
              color: "#388e3c",
              border: "1px solid #388e3c",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#c8e6c9",
                color: "#2e7d32",
                borderColor: "#2e7d32",
              },
            }}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
